import(/* webpackMode: "eager" */ "/vercel/path0/app/[lang]/corruption/page.tsx");
